/**
 * Created by zzy on 2019/8/1.
 */

// 动态加载js
var loadedjsElementFilePaths = []
export function loadJs(filePath, callback) {
  // 检测文件是否已加载
  if (loadedjsElementFilePaths.indexOf(filePath) !== -1) {
    callback()
    return
  }

  var jsElement = document.createElement('script')
  jsElement.setAttribute('type', 'text/javascript')
  jsElement.setAttribute('src', filePath)
  document.getElementsByTagName('head')[0].appendChild(jsElement)
  if (jsElement.readyState) { // IE
    jsElement.onreadystatechange = function () {
      if (jsElement.readyState === 'loaded' || jsElement.readyState === 'complete') {
        jsElement.onreadystatechange = null
        loadedjsElementFilePaths.push(filePath)
        callback()
      }
    }
  } else {
    loadedjsElementFilePaths.push(filePath)
    jsElement.onload = function () {
      loadedjsElementFilePaths.push(filePath)
      callback()
    }
  }
}

// 防抖(delay-延时，单位：毫秒）
// 作用：在一段时间内连续调用（每次调用间隔小于delay周期），只执行最后一次
var debounceTimeout = null // 创建一个标记用来存放定时器的返回值
export function debounce(fn, delay, context = this) {
  // 每当用户输入的时候把前一个 setTimeout clear掉
  if (debounceTimeout != null) {
    clearTimeout(debounceTimeout)
  }
  // 然后又创建一个新的 setTimeout, 这样就能保证interval 间隔内如果时间持续触发，就不会执行 fn 函数
  debounceTimeout = setTimeout(() => {
    fn.apply(context, arguments)
  }, delay)
}

// 节流阀(delay-延时，单位：毫秒）
// 作用：在一段时间内连续调用（每次调用间隔小于delay周期），每间隔delay周期执行一次
var throttleCanRun = true // 通过闭包保存一个标记
export function throttle(fn, delay, context = this) {
  // 在函数开头判断标记是否为true，不为true则return
  if (!throttleCanRun) return
  // 立即设置为false
  throttleCanRun = false
  // 将外部传入的函数的执行放在setTimeout中
  setTimeout(() => {
    // 最后在setTimeout执行完毕后再把标记设置为true(关键)表示可以执行下一次循环了。
    // 当定时器没有执行的时候标记永远是false，在开头被return掉
    fn.apply(context, arguments)
    throttleCanRun = true
  }, delay)
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// 对象是否有效
export const objectValid = function (obj) {
  if (obj != null && typeof (obj) !== 'undefined') {
    return true
  }
  return false
}

// 根据id获取对应名称
export const getNameById = function (id, arr) {
  if (objectValid(id) && arr) {
    for (let i = 0; i < arr.length; i++) {
      if (id === arr[i].id) {
        return arr[i].name
      }
    }
  }
  return ''
}

// 根据name获取对应id
export const getIdByName = function (name, arr) {
  if (objectValid(name) && name !== '' && arr) {
    for (let i = 0; i < arr.length; i++) {
      if (name === arr[i].name) {
        return arr[i].id
      }
    }
  }
  return null
}

// 根据id获取对应记录行
export const getRecordById = function (id, arr) {
  if (objectValid(id) && arr) {
    for (let i = 0; i < arr.length; i++) {
      if (id === arr[i].id) {
        return arr[i]
      }
    }
  }
  return null
}

// 根据name获取对应记录行
export const getRecordByName = function (name, arr) {
  if (objectValid(name) && name !== '' && arr) {
    for (let i = 0; i < arr.length; i++) {
      if (name === arr[i].name) {
        return arr[i]
      }
    }
  }
  return null
}

// 根据id获取对应索引
export const getIndexById = function (id, arr) {
  if (objectValid(id) && arr && arr.length > 0) {
    for (let i = 0; i < arr.length; i++) {
      if (id === arr[i].id) {
        return i
      }
    }
  }
  return -1
}



// WEBPACK FOOTER //
// ./src/utils/public.js